export default [
  {
    path: "/salary:/:userId",
    name: "user-salary",
    meta: {
      title: "ЗП сотрудника",
      authRequired: true,
    },
    component: () => import("@/modules/salary/views/items.vue"),
  },
];
